import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { RouterProvider } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { HelmetProvider } from 'react-helmet-async'
import { router } from '@gamecodex/wargame-ui'
import { setActiveWargameConfig } from '@gamecodex/wargame-config'
import { titanvellConfig } from './wargame.config'
import './index.css'

// Register the active wargame config before anything renders.
setActiveWargameConfig(titanvellConfig)

// Apply this site's accent colors as CSS custom properties — lets the shared
// shell's components (which read `var(--wg-primary)`) recolor per setting
// without any Tailwind theme change.
document.documentElement.style.setProperty('--wg-primary', titanvellConfig.branding.colors.primary)
document.documentElement.style.setProperty('--wg-accent', titanvellConfig.branding.colors.accent)

const queryClient = new QueryClient()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </HelmetProvider>
  </StrictMode>,
)
